import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from 'angularfire2/firestore';
import { FirestoreService } from './firestore/firestore.service';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/combineLatest';
import 'rxjs/add/operator/mergeMap';

import { Globals } from '../globals';

export interface Parent {
  active: boolean;
  createdAt: any;
  updatedAt: any;

  name: string;
  birthdate: string;
  semester: number;
  assignments: string[];

}

interface ParentId extends Parent {
  id: string;
}

@Injectable()
export class ParentService {

  parentCollection: AngularFirestoreCollection<Parent>;
  parents: any;

  parentDocument: AngularFirestoreDocument<ParentId>;
  parent: Observable<ParentId>;

  collection: string;

  // NOTE: Change this any for Parent Interface
  parent$: Observable<any>;
  parents$: Observable<any[]>;

  constructor(
    private afs: AngularFirestore,
    private afh: FirestoreService,
    private router: Router
  ) {
    this.collection = Globals.PARENT_COLLECTION;
  }

  /**
   * Get all parents with references
   * @return {Observable} Arrays of parents
   */
  getParents(): Observable<ParentId[]> {
    return this.afh.colWithIds$(this.collection, ref => ref.where('active', '==', true) );
  }
  
  /**
  * Get parent data
  * @param {string} sid - The id of the parent
  * @return {Observable} The Parent Object
  */
  getParent(sid: string): Observable<ParentId> {
    return this.afh.docWithIds$(this.collection + '/' + sid);
  }

  /**
  * Create new parent
  * @param {Parent} parent - The data of the parent
  */
  addParent(parent: Parent) {
    this.afh.add(`${this.collection}`, parent);
  }

  /**
   * Update current parent
   * @param {string} sid  - The id of the parent
   * @param {Parent} parent - The data of the parent
   */
  updateParent(sid: string, parent: Parent) {
    this.afh.update(`${this.collection}/${sid}`, parent);
  }

  /**
   * Delete current parent
   * @param {string} sid - The id of the parent
   */
  deleteParent(sid: string) {
    this.afh.delete(`${this.collection}/${sid}`);
  }

  windowReplace(action: string, id?: string){
    switch(action){
      case 'add':
      case 'create':
        this.router.navigate([`/new_parent`]);
        break;
      case 'edit':
      case 'update':
        this.router.navigate([`/edit_parent/${id}`]);
        break;
      case 'view':
      case 'display':
        this.router.navigate([`/vw_parent/${id}`]);
        break;
      case 'read':
        this.router.navigate([`/parent`]);
        break;
      default:
        console.log('Not an action');
    }
  }
}

export class ParentData {

  assignments = {
    key0: 'Gramar',
    key1: 'Math',
    key2: 'Social studies',
    key3: 'Science',
    key4: 'Acconting',

  }
}
